import Info from '@mui/icons-material/Info'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import { StyledIconButton } from '../../../theme/components/StyledIconButton'
import type { HistorySelection } from '../types/HistorySelection'
import type { HoofdnetOpdracht } from '../types/HoofdnetOpdracht'

interface Props {
  opdracht: HoofdnetOpdracht
  onOpenHistory: (selection: HistorySelection) => void
}

export const HoofdnetOpdrachtStatus = ({ opdracht, onOpenHistory }: Props) => {
  return (
    <>
      <Grid container spacing={2} sx={{ m: 'auto', width: '95%', p: 1 }}>
        <Grid size={{ xs: 3 }}>
          <Typography gutterBottom variant="subtitle1">
            <b>Status</b>
          </Typography>
          <Typography variant="body2">
            {opdracht.statusText}{' '}
            <StyledIconButton
              icon={<Info />}
              title="Open opdracht historie"
              onClick={() => onOpenHistory({ changedField: 'opdracht' })}
            ></StyledIconButton>
          </Typography>
        </Grid>

        <Grid size={{ xs: 3 }}>
          <Typography gutterBottom variant="subtitle1">
            <b>Planning status</b>
          </Typography>
          <Typography variant="body2">
            {opdracht.planStatusText}{' '}
            <StyledIconButton
              icon={<Info />}
              title="Open planning historie"
              onClick={() => onOpenHistory({ changedField: 'planning' })}
            ></StyledIconButton>
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}
